module.exports = __webpack_public_path__ + "img/watch2.8106b93c.png";